"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogicalCondition = exports.isComparisonCondition = exports.isArrayCondition = void 0;
var array_operators_1 = require("./array-operators");
var comparison_operators_1 = require("./comparison-operators");
var logical_operators_1 = require("./logical-operators");
exports.isArrayCondition = function (filter) {
    return filter.operator in array_operators_1.arrayOperators;
};
exports.isComparisonCondition = function (filter) {
    return filter.operator in comparison_operators_1.comparisonOperators;
};
exports.isLogicalCondition = function (filter) {
    return filter.operator in logical_operators_1.logicalOperators;
};
//# sourceMappingURL=ifilterconditions.js.map